"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FullStory = require("@fullstory/browser");
const state_1 = require("@airstudio/state");
class Fullstory extends state_1.Extensions.Abstract {
    constructor() {
        super();
        this.key = 'fullstory';
        state_1.Bus.onConfigReady(({ fullstory }) => {
            if (!fullstory) {
                // tslint:disable-next-line: no-console
                return console.warn('Fullstory extension is activated but backend config did not provide a `fullstory` value');
            }
            FullStory.init(fullstory);
            this.dispatchSuccess({});
        });
        state_1.Bus.onUserReady(({ userId }) => {
            FullStory.identify(userId);
        });
    }
}
exports.Fullstory = Fullstory;
//# sourceMappingURL=index.js.map